module.exports = __webpack_public_path__ + "assets/24a143a01b2fedd02f10190c80c101f5.site-logo-small.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/site-logo-small.svg
 ** module id = 842
 ** module chunks = 1
 **/